import { useEffect, useRef } from 'react'

interface DismissLayer {
	dismiss: () => void
}

// Overlays register in open order, so Escape only closes the topmost one.
const layers: DismissLayer[] = []

function handleKeyDown (e: KeyboardEvent) {
	if (e.key !== 'Escape' || layers.length === 0) return
	layers[layers.length - 1].dismiss()
}

/**
 * Closes an overlay on Escape without also closing the overlays beneath it,
 * e.g. a select dropdown opened inside a modal.
 */
export function useDismissLayer (active: boolean, onDismiss: () => void) {
	const onDismissRef = useRef(onDismiss)

	useEffect(() => {
		onDismissRef.current = onDismiss
	})

	useEffect(() => {
		if (!active) return

		const layer: DismissLayer = { dismiss: () => { onDismissRef.current() } }
		if (layers.length === 0) document.addEventListener('keydown', handleKeyDown)
		layers.push(layer)

		return () => {
			layers.splice(layers.indexOf(layer), 1)
			if (layers.length === 0) document.removeEventListener('keydown', handleKeyDown)
		}
	}, [active])
}
